import React from 'react'
import ChangeLogDrawer from './change-log-drawer'
import {
    Icon,
    useDisclosure,
} from '@chakra-ui/react'
import { MdHistory } from 'react-icons/md'
import ActionButton, { ActionButtonProps } from '~components/shared/buttons/action-button'

interface Props extends Omit<ActionButtonProps, 'icon' | 'tooltipLabel'> {
    entityId: string
}

export default function ChangeLogButton({ entityId, ...props }: Props) {
    const { isOpen, onOpen, onClose } = useDisclosure()

    return (
        <>
            <ActionButton
                tooltipLabel="View Change Log"
                icon={<Icon as={MdHistory} fontSize='18px' />}
                size='xs'
                h='32px'
                w='32px'
                onClick={onOpen}
                {...props}
            />
            <ChangeLogDrawer
                entityId={entityId}
                isOpen={isOpen}
                onClose={onClose}
            />
        </>
    )
}
